// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


.flatpickr-months .flatpickr-month {background-color: #8A36FF !important }
.flatpickr-current-month .flatpickr-monthDropdown-months{background-color: #8A36FF !important}
span.flatpickr-weekday {background-color: #8A36FF !important;color:#ffffff!important}
.flatpickr-weekdays{background-color: #8A36FF !important;}
.flatpickr-day.selected{
  background-color: #8A36FF !important;
  border:#8A36FF
}

.active-dev-pagination a{
  background-color: #2E3191!important;
  color:#ffffff
}

.select__value-container {
  flex-wrap: nowrap!important;
  overflow-x: auto!important;
  max-width:150px;
}

.select__value-container .select__multi-value {
  flex: 0 0 auto;
}

.active-dev-pagination a:hover{
  color:#ffffff
}
button {
  -webkit-tap-highlight-color: transparent;
}


/* Remove background from react-grid-layout placeholder */
.react-grid-placeholder {
  background: transparent !important;
  opacity: 0 !important;
}

/* Remove background from grid items on hover/active */
.react-grid-item {
  background: transparent !important;
  transition: none !important;
}

.react-grid-item.react-grid-placeholder {
  background: transparent !important;
}

/* Remove resize handle styling if needed */
.react-resizable-handle {
  background: none !important;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;;AAGA,oCAAoC,qCAAqC;AACzE,yDAAyD,oCAAoC;AAC7F,wBAAwB,oCAAoC,CAAC,uBAAuB;AACpF,oBAAoB,oCAAoC,CAAC;AACzD;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;AACA;EACE,wCAAwC;AAC1C;;;AAGA,yDAAyD;AACzD;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,uBAAuB;AACzB","sourcesContent":["/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n\n.flatpickr-months .flatpickr-month {background-color: #8A36FF !important }\n.flatpickr-current-month .flatpickr-monthDropdown-months{background-color: #8A36FF !important}\nspan.flatpickr-weekday {background-color: #8A36FF !important;color:#ffffff!important}\n.flatpickr-weekdays{background-color: #8A36FF !important;}\n.flatpickr-day.selected{\n  background-color: #8A36FF !important;\n  border:#8A36FF\n}\n\n.active-dev-pagination a{\n  background-color: #2E3191!important;\n  color:#ffffff\n}\n\n.select__value-container {\n  flex-wrap: nowrap!important;\n  overflow-x: auto!important;\n  max-width:150px;\n}\n\n.select__value-container .select__multi-value {\n  flex: 0 0 auto;\n}\n\n.active-dev-pagination a:hover{\n  color:#ffffff\n}\nbutton {\n  -webkit-tap-highlight-color: transparent;\n}\n\n\n/* Remove background from react-grid-layout placeholder */\n.react-grid-placeholder {\n  background: transparent !important;\n  opacity: 0 !important;\n}\n\n/* Remove background from grid items on hover/active */\n.react-grid-item {\n  background: transparent !important;\n  transition: none !important;\n}\n\n.react-grid-item.react-grid-placeholder {\n  background: transparent !important;\n}\n\n/* Remove resize handle styling if needed */\n.react-resizable-handle {\n  background: none !important;\n  border: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
